// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__AGc7m"};